/**
 * Copyright (c) 2021-2024 Kognitos, Inc. All rights reserved.
 */

import { CloseOutlined } from '@ant-design/icons';
import Button from '@/uiKit/components/general/Button';
import React, { FC } from 'react';
import { Flex } from 'antd';

interface CloseableMessageProps {
  message: string | React.ReactNode;
  closeIcon?: React.ReactNode;
  onClose?: () => void;
}
const CloseableMessage: FC<CloseableMessageProps> = ({
  message,
  onClose,
  closeIcon
}) => {
  return (
    <Flex align="center">
      <span>{message}</span>
      <Button onClick={onClose} type="text" title="close">
        {closeIcon || <CloseOutlined />}
      </Button>
    </Flex>
  );
};

export default CloseableMessage;
